//remove target _blank oon translation

window.addEventListener('load', (event) => {
 
 
  if (document.getElementsByClassName('nav-bar__link link')){  
    var slides = document.getElementsByClassName('nav-bar__link link');
    
    if (slides.length >= 9 ){
    console.log('desktop ' + slides.length);
    	for(var i = 0; i < slides.length; i++)
		{
        
          if (slides[i].innerHTML == 'FR'|| slides[i].innerHTML == 'EN'){
            slides[i].setAttribute("target", "_self");                         
                    
          }
          
        }  
    
    }
		
  }
  
  if (document.getElementsByClassName('mobile-menu__nav-link')){  
    var slides = document.getElementsByClassName('mobile-menu__nav-link');	
    console.log('mobile ' + slides.length);
    if (slides.length >= 9 ){
    
    for(var i = 0; i < slides.length; i++)
		{
        
          if (slides[i].innerHTML == 'FR'|| slides[i].innerHTML == 'EN'){
            slides[i].setAttribute("target", "_self");    
            var newURL = window.location.host;
            if (newURL == 'fr.tennisgiant.com'){
              slides[i].innerHTML = 'EN';
              slides[i].href = 'https://tennisgiant.com'
            }else{
             slides[i].innerHTML = 'FR';
              slides[i].href = 'https://fr.tennisgiant.com'
            }
            
          }
          
        }  
    
    }
    
  }
  
  
  
  if (document.getElementById('tg_lang_french')){
    	var newURL = window.location.host;
        if (newURL == 'fr.tennisgiant.com'){
             document.getElementById('tg_lang_french').style.display = 'block';
             document.getElementById('tg_lang_english').style.display = 'none';  
        }
    	else{
             document.getElementById('tg_lang_french').style.display = 'none';
        	 document.getElementById('tg_lang_english').style.display = 'block';
        }
    
    }
  
  
 //black out screen
   if (document.getElementById('tg_count-down_expired')){
               setTimeout(countDown, 1000);
   } else if (document.getElementById('tg_count-down_background') && document.getElementById('shopify-section-1620870650f6a7b12c')) {
    
       var countBlackout = '<div id="tg_count-down_background" style="z-index: 10; height: 100%; width: 100%; background-color: black; color: white; text-align: center; padding: 40px; position: fixed; top: 0px; left: 0px; opacity: 0.9;display:none;"> <div class="shopify-section" style="margin-left:30%;display: block; z-index: 0;width:40%;margin-top: 20vh;position:relative;z-index:1;background-color:#ffffff;padding:1%;border:solid 1px black;border-radius:5px;"><img src="https://cdn.shopify.com/s/files/1/1218/5228/files/tg_logo_black_2020_aacdc073-281b-437f-a2fc-a1002c2c668f_300x@2x.png?v=1628533930" width="100%" alt=""></div><div style="display: block; text-align: center; padding: 40px; font-size: 2em; margin-top: 0vh;">Black Friday</div><div id="tg_count-down" style="text-align: center; padding: 40px; font-size: 2.5em;"></div></div>';
     
       if (document.body != null){  
         
      	console.log(window.location.href);
         
       if(window.location.href.indexOf('tennisgiant') != -1){
      // setTimeout(countDown, 1);
       
       }
       
	}
  }


  
});





function addFreeItem(a,b){  
  
	console.log(update_cartFreeItem(a,b));  
   
  setTimeout(function(){ window.location.href= '/cart'; }, 1000);
}



function update_cartFreeItem(a,b){ 
  
  let formData = { 
		'items': [
          {  
		'id': a,  
		'quantity': 1  
		},
          {  
		'id': b,  
		'quantity': 1  
		}
        ]
	};
  
	fetch('/cart/add.js', {
  		method: 'POST',
  			headers: {
     		'Content-Type': 'application/json'
  			},
  			body: JSON.stringify(formData)
			})
			.then(response => {
  			return response.json();
			})
			.catch((error) => {  
			console.error('Error:', error);
});  
  
  
  
}



function tg_continue_Shopping(){ 
   var l_collection = document.referrer;
  	if (l_collection.indexOf("collections") > -1) {
    var m = l_collection.indexOf('/collections/');
    var n = l_collection.indexOf('/', m + 13);
      
      if (m < n ){     
        var url = l_collection.substring(0, n);       
      }else{      
        var url = l_collection;      
      }
   		setTimeout(function(){ window.location.href= url; }, 100);
        	
  	}
  else{
    var url = 'https://tennisgiant.com/'; 
    
    var newURL = window.location.host;
          if (newURL == 'fr.tennisgiant.com'){
            url = 'https://fr.tennisgiant.com/';
          }
    
    setTimeout(function(){ window.location.href= url; }, 100);
  
  }
  
}

var daysremaining = 1*24*60*60*1000;
var countDownDate = new Date("Nov 26, 2021 00:00:00").getTime();
        function countDown(){
 

            if (document.getElementById('tg_count-down')){
                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = countDownDate - now;
             //console.log(distance);
             
              if (distance > daysremaining + 21600000 + 3600000) {  return; }
              
              if (distance > daysremaining + 21600000 && distance < daysremaining + 21600000 + 3600000) {setTimeout(countDown, 1000); return; }
              
              if (document.getElementById('tg_count-down_background')){              	
                	//document.getElementById('tg_count-down_background').style.display = 'block';
               }
                 
              

                // Time calculations for days, hours, minutes and seconds
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // Display the result in the element with id="demo"
                document.getElementById('tg_count-down').innerHTML = days + 'd ' + hours + 'h '
                + minutes + 'm ' + seconds + 's';
  
              if (document.getElementsByClassName('slideshow__title heading h1')){ 
                 var slides = document.getElementsByClassName('slideshow__title heading h1');	
                for(var i = 0; i < slides.length; i++){
                   slides[i].innerHTML = days + 'd ' + hours + 'h '
                + minutes + 'm ' + seconds + 's';
                }
                 
              }
              
              
  				if (document.getElementsByClassName('slideshow__button button')){ 
                 var slides = document.getElementsByClassName('slideshow__button button');	
                for(var i = 0; i < slides.length; i++){
                  if (slides[i].innerHTML == 'SHOP BLACK FRIDAY'){
                    slides[i].style.display = 'none';
                    //slides[i].style.backgroundColor = "#ffffff";
                    //slides[i].setAttribute('href', 'https://fr.tennisgiant.com');
                    
                  }
                  
                  
                }
                 
              }
              //console.log(distance/(60*60*1000));
            }

            if (distance < 0*daysremaining) {
              if (document.getElementById('tg_count-down')){
              	document.getElementById('tg_count-down').innerHTML = '';
                document.getElementById('tg_count-down').style.display = 'none';
              }
                if (document.getElementById('tg_count-down_background')){
              	document.getElementById('tg_count-down_background').innerHTML = '';
                document.getElementById('tg_count-down_background').style.display = 'none';
              }
              
              if (document.getElementsByClassName('slideshow__title heading h1')){ 
                 var slides = document.getElementsByClassName('slideshow__title heading h1');	
                for(var i = 0; i < slides.length; i++){
                   slides[i].innerHTML = '';
                }
                 
              }
              
               if (document.getElementsByClassName('slideshow__button button')){ 
                 var slides = document.getElementsByClassName('slideshow__button button');	
                for(var i = 0; i < slides.length; i++){
                  if (slides[i].innerHTML == 'SHOP BLACK FRIDAY'){
                   
                     
                     slides[i].style.backgroundColor = '#ffffff';
                     slides[i].setAttribute('href', '/collections/black-friday-sale');
                     slides[i].style.display = 'block';
                     slides[i].style.width = 'auto';
                     slides[i].style.maxWidth = '250px';
                    
                     slides[i].style.marginLeft = 'auto';
                     slides[i].style.marginRight = 'auto';
                    
                    
                    
                    
                  }
                  
                  
                }
                 
              }
    
            }else{
              	
              if (document.getElementById('tg_count-down_background')){              	
                	//document.getElementById('tg_count-down_background').style.display = 'block';
               }
                setTimeout(countDown, 1000);
            }


}


//select string options bundle
function selectStringOptions(a) {
 
   document.getElementById('product-options-errors').style.display = 'none';
  
 
		
  if (a == 'data-field-select-2306665'){
    console.log('index ' + document.getElementById(a).selectedIndex);
    if (document.getElementById(a)){
      if (document.getElementById(a).selectedIndex == 2){
         showStringOptions('block');
        
         for(var i = 2306668; i <= 2306671; i++){
    		if (document.getElementById('data-field-id-' + i)){
    			document.getElementById('data-field-id-' + i).style.display = 'none';
    		}
         }
        
               
      }else if (document.getElementById(a).selectedIndex == 3){
         showStringOptions('block');
        for (var i = 2306666; i <= 2306667; i++){
    		if (document.getElementById('data-field-id-' + i)){
    			document.getElementById('data-field-id-' + i).style.display = 'none';
    		}
         }
        
        
      }else{
         showStringOptions('none');
        
      }
     
    }
    showStringSummary();
  }
  if (a == 'data-field-select-2306666'){
   console.log(document.getElementById(a).value);
  }

}

function showStringOptions(a) {
		
  for(var i = 2306666; i <= 2306674; i++){
    if (document.getElementById('data-field-id-' + i)){
    document.getElementById('data-field-id-' + i).style.display = a;
    }
  }

}
function verifyStringOptions(a,b,q,product){
   
 
  var errorMessage = '';
  var errorBolean = true;
  
  for (var i = 2306665; i <= 2306673; i++) {
    if (document.getElementById('data-field-id-' + i)){
    	if (document.getElementById('data-field-id-' + i).style.display == 'block' && document.getElementById('data-field-select-' + i).selectedIndex < 1){
    		errorMessage = errorMessage + document.getElementById('data-field-select-' + i).value + ' ' + document.getElementById('data-field-title-' + i).innerHTML + '<br>';
    		errorBolean = false;
            
        }
    
    
    }
 
  }
  
   var qty = 1
   var raqId;
   if (document.getElementById('product-select-' + a)){
    	
    raqId = document.getElementById('product-select-' + a).value;
     if (parseInt(b[document.getElementById('product-select-' + a).selectedIndex]) < qty){
     	qty = b[document.getElementById('product-select-' + a).selectedIndex];
     }
   }else{
     
     errorMessage = errorMessage + 'data error' + '<br>';
     errorBolean = false;   
   }
 
  if (parseInt(qty) < 1){
  	 errorMessage = errorMessage + 'Not Available/Non disponible' + '<br>';
     errorBolean = false;
  }
  
  
 	if (errorBolean == false){ 
       document.getElementById('product-options-errors').innerHTML = errorMessage;
      document.getElementById('product-options-errors').style.display = 'block';
      return;
    }else{
    addTennisOptions(a, b, q, product);
    }
   
}

function showStringSummary(){
  var a = 'data-field-select-2306665';
  var additionalCost = 0;
 
  if (a == 'data-field-select-2306665'){
    if (document.getElementById(a)){
      
      if (document.getElementById(a).selectedIndex > 1){      
        document.getElementById('data-field-id-2306680').style.display = 'none';
       
        var stringSummaryText = '<div class="pricing-info-product-title">' +  document.getElementById('data-field-title-2306665').innerHTML + ': ' +  document.getElementById(a).value + '</div>';
       
        if (document.getElementById('data-field-id-2306666').style.display == 'block' && document.getElementById('data-field-select-2306666').selectedIndex > 0){
        stringSummaryText = stringSummaryText +'<div class="pricing-info-product-title">' +  document.getElementById('data-field-title-2306666').innerHTML + ': ' +  document.getElementById('data-field-select-2306666').value + '</div>';
      	var sel = document.getElementById('data-field-select-2306666');
		var selected = sel.options[sel.selectedIndex];
		var extra = selected.getAttribute('data-price');          
        var extraid = selected.getAttribute('data-id');
          additionalCost = parseInt(extra);
          document.getElementById('data-field-id-2306680').style.display = 'block';
        
        }
        if (document.getElementById('data-field-id-2306668').style.display == 'block' && document.getElementById('data-field-select-2306668').selectedIndex > 0){
        stringSummaryText = stringSummaryText +'<div class="pricing-info-product-title">' +  document.getElementById('data-field-title-2306668').innerHTML + ': ' +  document.getElementById('data-field-select-2306668').value + '</div>';
        var sel = document.getElementById('data-field-select-2306668');
		var selected = sel.options[sel.selectedIndex];
		var extra = selected.getAttribute('data-price');          
        var extraid = selected.getAttribute('data-id');
          additionalCost = parseInt(extra);
         document.getElementById('data-field-id-2306680').style.display = 'block';
        }
        if (document.getElementById('data-field-id-2306670').style.display == 'block' && document.getElementById('data-field-select-2306670').selectedIndex > 0){
        stringSummaryText = stringSummaryText +'<div class="pricing-info-product-title">' +  document.getElementById('data-field-title-2306670').innerHTML + ': ' +  document.getElementById('data-field-select-2306670').value + '</div>';
       var sel = document.getElementById('data-field-select-2306670');
		var selected = sel.options[sel.selectedIndex];
		var extra = selected.getAttribute('data-price');          
        var extraid = selected.getAttribute('data-id'); 
           additionalCost = parseInt(additionalCost) + parseInt(extra);
           document.getElementById('data-field-id-2306680').style.display = 'block';
        }
              
        document.getElementById('data-summary-id-2306680').innerHTML = stringSummaryText;
        if (parseInt(additionalCost) > 0 ){
             document.getElementById('data-total-id-2306680').innerHTML = '$' + (parseInt(additionalCost)/100).toFixed(2);
      }else{
      	document.getElementById('data-total-id-2306680').innerHTML = '$' + (parseInt(additionalCost)).toFixed(2);
      }
        
        
      }else{
        document.getElementById('data-field-id-2306680').style.display = 'none';
      }
    }
  }

}


function addTennisOptions(a, b, q, product){ 
  
 
   
  var qty = 1; //document.getElementsByClassName(q)[0].value;  
  var slides = document.getElementsByClassName(q);  
  for(var i = 0; i < slides.length; i++){
    
    const aName = document.getElementsByClassName(q)[i];
	const aValue = aName.getAttribute('name');
   
    
    
    if (aValue == 'quantity'){
    	qty = document.getElementsByClassName(q)[i].value;
    }
  }
  
   var raqId;
   if (document.getElementById('product-select-' + a)){
     	
    raqId = document.getElementById('product-select-' + a).value;
     if (parseInt(b[document.getElementById('product-select-' + a).selectedIndex]) < qty){
     qty = b[document.getElementById('product-select-' + a).selectedIndex];
     }
   }else{return;}
  
    
  const properties = new Object();
  
  let formData = { 
		'items': [
          {  
		'id': raqId,  
		'quantity': qty,
        'properties': {
            'promotion': 'Squash & Pickleball'
        }
        }
        ]
	};
  
 
  var understandKey;
  var understandVal;
  for (var i = 2306665; i <= 2306674; i++) {  
   
   if (document.getElementById('data-field-id-' + i)){
     if (document.getElementById('data-field-id-' + i).style.display == 'block'){
       var newKey = document.getElementById('data-field-title-' + i).innerHTML;
       var newVal = document.getElementById('data-field-select-' + i).value;  
       
       if (i == 2306673){
        var understandKey = document.getElementById('data-field-title-' + i).innerHTML;
        var understandVal = document.getElementById('data-field-select-' + i).value; 
       }
       
       
       formData.items[0].properties[newKey] = newVal;     
     }    
    }    
  }
  delete formData.items[0].properties.promotion;
  
   if (document.getElementById('data-field-id-2306666').style.display == 'block' && document.getElementById('data-field-select-2306666').selectedIndex > 0){
       	var sel = document.getElementById('data-field-select-2306666');
		var selected = sel.options[sel.selectedIndex];
		var extra = selected.getAttribute('data-price');          
        var extraid = selected.getAttribute('data-id');
     if (parseInt(extraid) > 0 ) {
     formData.items[0].properties['Bundle'] = raqId + '-' + extraid;
     }
     
          
     let form230666 = {'id':extraid,'quantity': qty,'properties':{'Re': product, 'Bundle': formData.items[0].properties['Bundle']}}
     form230666.properties[understandKey] = understandVal;
      //delete form230666.properties.promotion;
     if (document.getElementById('data-field-select-2306666').selectedIndex > 1){
     	formData.items.push(form230666);
     }
     
        
   }
  
   if (document.getElementById('data-field-id-2306668').style.display == 'block' && document.getElementById('data-field-select-2306668').selectedIndex > 0){
       	var sel = document.getElementById('data-field-select-2306668');
		var selected = sel.options[sel.selectedIndex];
		var extra = selected.getAttribute('data-price');          
        var extraid = selected.getAttribute('data-id');
     if (parseInt(extraid) > 0 ) {
     formData.items[0].properties['Bundle'] = raqId + '-' + extraid;
     }
     
     var seckey = document.getElementById('data-field-title-2306666').innerHTML;
     var secval = document.getElementById('data-field-title-2306668').innerHTML;
          
     let form230668 = {'id':extraid,'quantity': qty,'properties':{'Re': product, 'Bundle': formData.items[0].properties['Bundle'] }}
     form230668.properties[seckey] = secval;
     form230668.properties[understandKey] = understandVal;
      //delete form230668.properties.promotion;
     if (document.getElementById('data-field-select-2306668').selectedIndex > 1){
     	formData.items.push(form230668);
     }
     
        
   }
  
  if (document.getElementById('data-field-id-2306670').style.display == 'block' && document.getElementById('data-field-select-2306670').selectedIndex > 0){
       	var sel = document.getElementById('data-field-select-2306670');
		var selected = sel.options[sel.selectedIndex];
		var extra = selected.getAttribute('data-price');          
        var extraid = selected.getAttribute('data-id');
    if (parseInt(extraid) > 0 ) {
    formData.items[0].properties['Bundle'] = formData.items[0].properties['Bundle'] + '-' + extraid; 
    if (formData.items.length > 1){
       formData.items[1].properties['Bundle'] = formData.items[0].properties['Bundle'];
    }
    }
    
    var seckey = document.getElementById('data-field-title-2306666').innerHTML;
    var secval = document.getElementById('data-field-title-2306670').innerHTML;
          
    let form230670 = {'id':extraid,'quantity': qty,'properties':{'Re': product, 'Bundle': formData.items[0].properties['Bundle']}}
    form230670.properties[seckey] = secval;
    form230670.properties[understandKey] = understandVal;
      //delete form230670.properties.promotion;
    if (document.getElementById('data-field-select-2306670').selectedIndex > 1){
     formData.items.push(form230670);
    }
   
        
   }
  
  
  var timestampnow = new Date().getTime();
  
  for(var i = 0; i < formData.items.length; i++){
    if ( "Bundle" in formData.items[i].properties){
    formData.items[i].properties['Bundle'] = formData.items[i].properties['Bundle'] + '-' + timestampnow;
    }
  }
  
 
  
  
  fetch('/cart/add.js', {
      method: 'POST',
  			headers: {
     		'Content-Type': 'application/json'
  			},
  			body: JSON.stringify(formData)
			})
			.then(response => {
    setTimeout(function(){ window.location.href= '/cart'; }, 100);
  			return response.json();
			})
			.catch((error) => {  
			console.error('Error:', error);
      		
});  
  
  
   
}

function updateTennisOptions(a, b, c, q, m){
  
  var dataBundle = [];
  var dataId = [];
  var dataLine = [];
  var dataInventory = [];
  var dataKey = [];
  
  
  if (document.getElementById('bundled_data_information')){
  var aValue0 = document.getElementById('bundled_data_information').getAttribute('data-bundle-bundle');
    dataBundle = aValue0.split(',');   
  var aValue1 = document.getElementById('bundled_data_information').getAttribute('data-bundle-id');
    dataId = aValue1.split(',');    
  var aValue2 = document.getElementById('bundled_data_information').getAttribute('data_bundle-line');
    dataLine = aValue2.split(','); 
  var aValue3 = document.getElementById('bundled_data_information').getAttribute('data-bundle-inventory');
    dataInventory = aValue3.split(',');
  var aValue4 = document.getElementById('bundled_data_information').getAttribute('data-bundle-key');
    dataKey = aValue4.split(',');
  }
  
  var myArrayInventory = [0,0,0];
  var myArrayLine = [0,0,0];
  for(var j = 0; j < dataBundle.length - 1; j++){  
    
  }
   
  
  const myArray = a.split('-');
  
  for(var i = 0; i < myArray.length - 1; i++){
    for(var j = 0; j < dataBundle.length - 1; j++){
      if (dataBundle[j] == a && dataId[j] == myArray[i]){
      myArrayLine[i] = dataLine[j];  
      myArrayInventory[i] = dataInventory[j];
        
      } 
    }   
  }
  
 
  
  
  if (parseInt(q) > parseInt(m) && parseInt(m) > 0){q = m;}
  
  if (parseInt(q) > parseInt(myArrayInventory[0])){return;}
  
  var slider = document.getElementById(c);

  
   let updateData = {
     'updates': []
    };
    
   
  
  for(var j = 0; j < dataBundle.length - 1; j++){
     if (dataBundle[j] == a && c.indexOf(dataKey[j]) < 0){      
       updateData.updates.push({"line":dataLine[j], "quantity": q});
     }
    } 
  
  if (updateData.updates.length > 1 && q == 0){
   updateData.updates[1].line = parseInt(updateData.updates[1].line) - 1;
  }
 
      fetch('/cart/change.js', {
      method: 'POST',
  			headers: {
     		'Content-Type': 'application/json'
  			},
         body: JSON.stringify(updateData.updates[0])
    
			})
			.then(response => {  
        ///
        	if (updateData.updates.length > 0){
          
          fetch('/cart/change.js', {
      		method: 'POST',
  			headers: {
     		'Content-Type': 'application/json'
  			},
    		body: JSON.stringify(updateData.updates[1])
    
			})
			.then(response => {
            setTimeout(function(){ slider.click(); }, 100);
             return response.json();
			})
			.catch((error) => {  
      		
      });            
            
            }else{setTimeout(function(){ slider.click(); }, 100);  }
        
        ///
         
  			return response.json();
        
        
			})
			.catch((error) => {  
      		
      });
  
  
  
}
//end select string options bundle

//select rental options bundle
function selectRentalOptions(a) {
 document.getElementById('product-options-errors').style.display = 'none';  
  
}
function showRentalSummary(){
 var a = 'data-field-select-2306665';
  var additionalCost = 0;
 
  if (a == 'data-field-select-2306665'){
    if (document.getElementById(a)){
      if (document.getElementById(a).selectedIndex > 1){
        document.getElementById('data-field-id-2306680').style.display = 'none';
        var stringSummaryText = '<div class="pricing-info-product-title">' +  document.getElementById('data-field-title-2306665').innerHTML + ': ' +  document.getElementById(a).value + '</div>';
        stringSummaryText = '';
       if (document.getElementById('data-field-id-2306665').style.display == 'block' && document.getElementById('data-field-select-2306665').selectedIndex > 0){
        stringSummaryText = stringSummaryText +'<div class="pricing-info-product-title">' +  document.getElementById('data-field-title-2306665').innerHTML + ': ' +  document.getElementById('data-field-select-2306665').value + '</div>';
      	var sel = document.getElementById('data-field-select-2306665');
		var selected = sel.options[sel.selectedIndex];
		var extra = selected.getAttribute('data-price');          
        var extraid = selected.getAttribute('data-id');
          additionalCost = parseInt(extra);
          document.getElementById('data-field-id-2306680').style.display = 'block';
        
        }
      
       document.getElementById('data-summary-id-2306680').innerHTML = stringSummaryText;
      if (parseInt(additionalCost) > 0 ){
             document.getElementById('data-total-id-2306680').innerHTML = '$' + (parseInt(additionalCost)/100).toFixed(2);
      }else{
      	document.getElementById('data-total-id-2306680').innerHTML = '$' + (parseInt(additionalCost)).toFixed(2);
      }
      
      
      }else{
       document.getElementById('data-field-id-2306680').style.display = 'none';
      }
    }
  
  }
}

function verifyRentalOptions(a,b,q,product){  
  
  var errorMessage = '';
  var errorBolean = true;
  
  for (var i = 2306665; i <= 2306673; i++) {
    
    if (document.getElementById('data-field-id-' + i)){
      
    	if (document.getElementById('data-field-id-' + i).style.display == 'block' && document.getElementById('data-field-select-' + i).selectedIndex < 1){
    		errorMessage = errorMessage + document.getElementById('data-field-select-' + i).value + ' ' + document.getElementById('data-field-title-' + i).innerHTML + '<br>';
    		errorBolean = false;
            
        }    
    
    }    
 
  }
   var qty = 1
   var raqId;
   if (document.getElementById('product-select-' + a)){
    	
     raqId = document.getElementById('product-select-' + a).value;
     if (parseInt(b[document.getElementById('product-select-' + a).selectedIndex]) < qty){
     	qty = b[document.getElementById('product-select-' + a).selectedIndex];
     }
   }else{
     
     errorMessage = errorMessage + 'no selection' + '<br>';
     errorBolean = false;   
   }
 
  //if out of stock
  if (parseInt(qty) < 1){
  	 errorMessage = errorMessage + 'Not Available/Non disponible' + '<br>';
     errorBolean = false;
  }
 
  //verify expired time
  const weekday = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const weekdayf = ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendred','Samedi'];
  var qq = 'product-form__selected-value';
  var dayHour = [];
  	var propertyslides = document.getElementsByClassName(qq);  
  	for(var i = 0; i < propertyslides.length; i++){  	
    	var qqvalue = 'block-swatch__item-text';
  		var propertyslidesvalue = document.getElementsByClassName(qqvalue);
   		//alert(document.getElementsByClassName(qq)[i].innerHTML);
    	for(var j = 0; j < propertyslidesvalue.length; j++){
      	var hostText = document.getElementsByClassName(qqvalue)[j].innerHTML;
      	var findText = document.getElementsByClassName(qq)[i].innerHTML;
     
        var findFI = weekday.indexOf(findText);
        var findTextf = weekdayf[findFI];
          
       		if (hostText.indexOf(findText) > -1){  
              dayHour.push(hostText)
         	}
         	if (hostText.indexOf(findTextf) > -1){  
              dayHour.push(hostText)
         	}
    	}
  	}
  
  var today = new Date();
    
   var verifyDay = dayHour[0];
   var verifyDayi = verifyDay.length;
   verifyDay = verifyDay.substr(verifyDayi -2, verifyDayi)
   var verifyHour = dayHour[1].substr(0 , 2)
   //alert(verifyDay + ' ' + today.getDate() + ' ' + verifyHour + ' ' + today.getHours())
   if (parseInt(verifyDay) <= today.getDate() && parseInt(verifyHour) <= today.getHours()){
   			errorMessage = errorMessage + 'Expired/Expiré' + '<br>';
     		errorBolean = false;
   }
  
  
  if (errorBolean == false){ 
       document.getElementById('product-options-errors').innerHTML = errorMessage;
      document.getElementById('product-options-errors').style.display = 'block';
      return;
    }else{
      addRentalOptions(a, b, q, product);
    }

}

function addRentalOptions(a, b, q, product){
  
 
  var qty = 1; //document.getElementsByClassName(q)[0].value;  
  var slides = document.getElementsByClassName(q);  
  for(var i = 0; i < slides.length; i++){
    
    const aName = document.getElementsByClassName(q)[i];
	const aValue = aName.getAttribute('name');
   
    
    
    if (aValue == 'quantity'){
    	qty = document.getElementsByClassName(q)[i].value;
    }
  }
  
   var raqId;
   if (document.getElementById('product-select-' + a)){
    	
    raqId = document.getElementById('product-select-' + a).value;
     if (parseInt(b[document.getElementById('product-select-' + a).selectedIndex]) < qty){
     	qty = b[document.getElementById('product-select-' + a).selectedIndex];
     }
   }else{return;}
  
   
  
  const properties = new Object();
  
  let formData = { 
		'items': [
          {  
		'id': raqId,        
		'quantity': qty,
        'properties': {
            'promotion': 'Squash & Pickleball'
        }
        }
        ]
	};
  
  
  //find select properties text
  var qqTitle = 'product-form__option-name text--strong';
  var Titleslides = document.getElementsByClassName(qqTitle);  
  var KeyTitle = [];
  for(var h = 0; h < Titleslides.length; h++){
    var foundKey = document.getElementsByClassName(qqTitle)[h].innerHTML;
    var foundKeyi = foundKey.indexOf(':');
    //alert(foundKeyi);
    foundKey = foundKey.substr(0, foundKeyi)   
    KeyTitle.push(foundKey)
  }
  
  	var qq = 'product-form__selected-value';
  	var propertyslides = document.getElementsByClassName(qq);  
  	for(var i = 0; i < propertyslides.length; i++){  	
    	var qqvalue = 'block-swatch__item-text';
  		var propertyslidesvalue = document.getElementsByClassName(qqvalue);
   		//alert(document.getElementsByClassName(qq)[i].innerHTML);
    	for(var j = 0; j < propertyslidesvalue.length; j++){
      	var hostText = document.getElementsByClassName(qqvalue)[j].innerHTML;
      	var findText = document.getElementsByClassName(qq)[i].innerHTML;
     
       		if (hostText.indexOf(findText) > -1){               
              formData.items[0].properties[KeyTitle[i]] = hostText; 
         	}
    	}
  	}
 
  
  
  var understandKey;
  var understandVal;
  for (var i = 2306665; i <= 2306674; i++) {  
   
   if (document.getElementById('data-field-id-' + i)){
     if (document.getElementById('data-field-id-' + i).style.display == 'block'){
       var newKey = document.getElementById('data-field-title-' + i).innerHTML;
       var newVal = document.getElementById('data-field-select-' + i).value;  
       
       if (i == 2306673){
        var understandKey = document.getElementById('data-field-title-' + i).innerHTML;
        var understandVal = document.getElementById('data-field-select-' + i).value; 
       }
       
       
       formData.items[0].properties[newKey] = newVal;     
     }    
    }    
  }
  delete formData.items[0].properties.promotion;
  
 
  
   if (document.getElementById('data-field-id-2306665').style.display == 'block' && document.getElementById('data-field-select-2306665').selectedIndex > 1){
       	var sel = document.getElementById('data-field-select-2306665');
		var selected = sel.options[sel.selectedIndex];
		var extra = selected.getAttribute('data-price');          
        var extraid = selected.getAttribute('data-id');
     if (parseInt(extraid) > 0 ) {
     formData.items[0].properties['Bundle'] = raqId + '-' + extraid;
     }
     
          
     let form230665 = {'id':extraid,'quantity': qty,'properties':{'Re': product, 'Bundle': formData.items[0].properties['Bundle']}}
     form230665.properties[understandKey] = understandVal;
      //delete form230666.properties.promotion;
     if (document.getElementById('data-field-select-2306665').selectedIndex > 1){
     	formData.items.push(form230665);
     }
     
        
   }
  
  
   var timestampnow = new Date().getTime();  
  for(var i = 0; i < formData.items.length; i++){
    if ( "Bundle" in formData.items[i].properties){
    formData.items[i].properties['Bundle'] = formData.items[i].properties['Bundle'] + '-' + timestampnow;
      
    }
  }
 
  
  
  
  fetch('/cart/add.js', {
      method: 'POST',
  			headers: {
     		'Content-Type': 'application/json'
  			},
  			body: JSON.stringify(formData)
			})
			.then(response => {
    setTimeout(function(){ window.location.href= '/cart'; }, 100);
  			return response.json();
			})
			.catch((error) => {  
			console.error('Error:', error);
      		
});   
  
  
}

function reveiwRentalDay(a){
  var al = a.length; 
  var aday = a.substring(al-1, al-0);
  var today = new Date();
  var dayofweek = today.getDay();
 
    
  if (document.getElementById('data-field-select-2306665').length > 4){
         var sell = document.getElementById('data-field-select-2306665').length;
         var sel = document.getElementById('data-field-select-2306665');  		
    
  	 if (aday >= 6 && sell > 3){ 
    	sel.options[3].style.display = 'block';
      	sel.options[4].style.display = 'block';
     }else{       
      if (sel.selectedIndex > 2) {sel.selectedIndex = 0;selectRentalOptions(0);showRentalSummary();}
        sel.options[3].style.display = 'none';
        sel.options[4].style.display = 'none';
     }  
    
  }
   

}
//end select rental options bundle

 